// IMPORTANT: this hook expects the workflow to be hydrated before it is called

import { useMemo } from "react";

import { UseGuardStepHook } from "../useGuardStep";
import { useParams } from "react-router-dom";
import { useCurrentWorkflow } from "@/store";

export const useGuardWorkflow: UseGuardStepHook = () => {
    const { workspaceUrl, workflowUrl } = useParams<{
        workspaceUrl: string;
        workflowUrl: string;
    }>();

    const currentWorkflow = useCurrentWorkflow();

    const authorizedWorkflow = useMemo(() => {
        if (workflowUrl && currentWorkflow && workflowUrl === currentWorkflow.url) return true;
        return false;
    }, [workflowUrl, currentWorkflow]);

    if (authorizedWorkflow) {
        return { loading: false, passThrough: true, errors: [] };
    }

    const errors = [];

    if (!workflowUrl) errors.push("No workflow specified");
    if (!currentWorkflow) errors.push("Workflow not found");
    if (workflowUrl && currentWorkflow && workflowUrl !== currentWorkflow?.url) {
        errors.push("Workflow URL mismatch");
    }

    return {
        loading: false,
        passThrough: false,
        errors,
        redirect: workspaceUrl ? `/${workspaceUrl}` : "/"
    };
};
